export default __webpack_public_path__ + "static/media/monkey-8.d62ff05c.png";